import { TOAST } from '@commoncore/constants/ToastMessages';
import { ListViewImplementation } from '@commoncore/implementation/ListViewImplementation';
import { CustomSortService } from '@commoncore/services/custom-sort.service';
import { MultiSelectLibrary } from '@commoncore/utils/MultiSelectUtil';
import { AppEvents } from '@commoncore/utils/app-events';

export class SharedFilesListImplementation {
  public router: any;
  public http: any;
  public route: any;
  public universalService: any;
  public multiSelect: any;
  public listService: any;
  contextMenuService: any;
  customMetadata: any;
  public sortType = "%2DlastModifiedDate";
  public sortByDateArray = [];
  customSort:any;
  listImpl:any;
  loggerService: any;
  sentEmpty: boolean;
  receivedEmpty: boolean;
  public nextLink: string="";
  public flag = false;
  public previousLink: string = "";
  public docheignt: number = 0;
  public toppos: number = 0;
  public listsize:number = 0;
  shareAccessService:any;
  localStorageService:any;
  sessionStorageService:any;
  static singleInstance:SharedFilesListImplementation
  cleverTapEventsService:any;
  recipientsObjRights = { // This is default owner rights
    "canDelete":true,
    "canCopy":true,
    "canDownload":true,
    "canEdit":true,
    "canRename":true,
    "canShare":true,
    "canView":true,
    "canAdd":true,
    "canRemove":true,
    "canComment":true
 }
 public currentPageNo = 0;
 public previousPageNo = -1;
 paginationService: any;
  globalService: any;
  public resizeableObjectList = []; // it is used only for resize window frame - do not overwrite or use.

  constructor(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.globalService = globalService;
  }

  public static getInstance(globalService):SharedFilesListImplementation{
		if(this.singleInstance == null){
			this.singleInstance = new SharedFilesListImplementation(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
  }

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.route = globalService.getActivatedRoute();
    this.loggerService = globalService.getLoggerServiceRef();
    this.multiSelect = MultiSelectLibrary.getInstance(globalService);
    this.listService = globalService.getListServiceRef();
    this.listImpl = ListViewImplementation.getInstance(globalService)
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.customSort = new CustomSortService(this.universalService);
    this.shareAccessService = globalService.getShareAccessServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.paginationService = globalService.getPaginationServiceRef();
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
  }

  fetchSharedObjectMetadata(url){
    var self = this;
    return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
            resp=>{
              resolve(resp)
            },
            err=>{
              resolve("fetchObjectMetadataAPIfailed")
            }
        )
    })
  }


  fetchFiles(url,tab,changedSortFromDropDown){
      var sort;
      if(this.shareAccessService.sortType == ""){
        sort = 'default'
      } else{
        sort = (this.shareAccessService.sortType=='lastModified')?'lm': 'sc';
      }
      // if(changedSortFromDropDown && !this.universalService.isMobileDevice){
      //   //setTimeout(() => { // this timeout is added to handle the refresh scenario/ 1st visit to this tab
      //     if(this.router.url.includes("/shared/"))
      //     this.listImpl.decideListOptions(tab == 'sent' ? 'sharedbyme' : 'sharedwithme');
      //   //}, 1000);
      // }else{
        if(tab == "sent"){
          this.fetchSentFiles(url,sort);
          this.cleverTapEventsService.onSharedByMeTabClick();
        } else{
          this.cleverTapEventsService.onSharedWithMeTabClick();
          return this.fetchReceivedFiles(url,sort)
        }
      // }
      
  }

  copyShareLink(shareUrl) {
    var self = this;
    if ( navigator.permissions == undefined) {
      const el = document.createElement("input");
      document.body.appendChild(el);
      el.value = shareUrl;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      self.universalService.showToast(TOAST["COPY_LINK_SUCCESS"], "success");
    }
    else{
      navigator.clipboard.writeText(shareUrl).then(function() {
        self.universalService.showToast(TOAST["COPY_LINK_SUCCESS"], "success");
      }, function() {
        console.log("Error while copying link");
      });
    }
  }

  deleteShareLink(url) {
    var self = this;
    return new Promise(function(resolve,reject){
        self.http.put(url).subscribe(
            resp=>{
              resolve(true);
            },
            err=>{
              resolve(false);
            }
        )
    })
  }

  deleteShareLinkFromList(shareKey, result) {
    var self = this;
    var selectedRowData = this.universalService.selectedNodes;
    this.universalService.showLoader = false;
    if (result) {
      this.universalService.showToast(TOAST["LINK_DELETED_SUCCESS"], "success");
      if (!this.universalService.isMobileDevice) {
        var res = this.listService.listOptions.api.applyTransaction({ remove: selectedRowData });
        var rowCount = this.listService.listOptions.api.getDisplayedRowCount();
        if (rowCount == 0) {
          this.universalService.emptySharedLink = true;
        }
      } else {
        this.universalService.showMobOptionMenu = false;
        this.universalService.disableModalBackdrop();
        this.shareAccessService.sharedFilesList.map(function (object, index) {
          if (object.shareKey == shareKey) {
            self.shareAccessService.sharedFilesList.splice(index, 1);
          }
        });

        if (this.shareAccessService.sharedFilesList.length == 0) {
          this.universalService.emptySharedLink = true;
        }

      }
      this.listImpl.hideSortingArrowForColumn(this.listService.listOptions,rowCount);
      return;
    }
    this.loggerService.log("error in deleting shared link", result)
    this.universalService.showErrorMessage(result);
  }

  fetchSharedLinkByMeList(url,sort,changedSortFromDropDown){
    var self = this;
    // if(changedSortFromDropDown && !this.universalService.isMobileDevice){
    //   // setTimeout(() => {
    //     this.cleverTapEventsService.onSharedLinkByMeTabClick();
    //     if(!this.universalService.emptySharedLink && this.router.url.includes("/shared/")){
    //       this.listImpl.decideListOptions('sharedlinkbyme');
    //     }
    //   // }, 1000);   
    //   // return   
    // }
    return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
            resp=>{
                self.resetData();
                self.paginationService.spliceAndSaveDataInLocalDB(resp["shares"]);
                self.fetchNextLink(resp);
                self.setFilesData(self.paginationService.getBufferDataForNextPage(self.currentPageNo),'sharedlinkbyme',sort);
                self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
            },
            err=>{
                self.loggerService.log("error in fetching shared link by me",err)
                self.universalService.showErrorMessage(err);
                self.universalService.isServerError = false;
            }
        )
    })
  }

  fetchSentFiles(url,sort){
      var self = this;
      return new Promise(function(resolve,reject){
          self.http.get(url).subscribe(
              resp=>{
                  self.resetData();
                  self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
                  self.fetchNextLink(resp);
                  self.setFilesData(self.paginationService.getBufferDataForNextPage(self.currentPageNo),'sent',sort);
                  self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
              },
              err=>{
                  self.loggerService.log("error in fetching favorites for my files",err)
                  self.universalService.showErrorMessage(err);
                  self.universalService.isServerError = false;
              }
          )
      })
  }

  fetchReceivedFiles(url,sort){
    var self = this;
    return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
            resp=>{
                self.resetData();
                self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
                self.fetchNextLink(resp);
                self.setFilesData(self.paginationService.getBufferDataForNextPage(self.currentPageNo),'received',sort);
                self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
                //check whether open preview or not
                self.shareAccessService.singleObjectShared =  self.sessionStorageService.getSingleSharedObject(true)
                if(self.shareAccessService.singleObjectShared != ""){
                  if(self.shareAccessService.singleObjectShared == "fileDeleted"){
                    self.universalService.deletedFileShare = true;
                    self.shareAccessService.singleObjectShared = ""
                    self.sessionStorageService.setSingleSharedObject(self.shareAccessService.singleObjectShared,true)
                    self.shareAccessService.singleObjectShared =  self.sessionStorageService.getSingleSharedObject(true)
                  }else{
                    resolve("showPreview");
                  }
                }
            },
            err=>{
                self.loggerService.log("error in fetching favorites for my albums",err)
                self.universalService.showErrorMessage(err);
                self.universalService.isServerError = false;
            }
        )
    })
  }

    setFilesData(objects,tab,sort){
      this.resizeableObjectList = objects;
      // var list = this.customMetadata.segregateData(resp,'allfiles');
      var list = this.customMetadata.segregateData(objects, tab);
      this.listsize = this.listsize + list.length;
      this.checkIfTabIsEmpty(list);
      if(this.universalService.emptyShared || this.universalService.emptySharedLink){
        this.universalService.disableModalBackdrop();
        this.universalService.showLoader = false;
        this.universalService.disableModalBackdrop();
        return
      } 
      if(!this.universalService.isMobileDevice){
        this.listImpl.decideListOptions(tab == 'sent' ? 'sharedbyme' : (tab == "received" ? 'sharedwithme' : "sharedlinkbyme"));
        if(tab == 'sent'){
          this.listImpl.fetchSentFilesListView(list)
        } else if (tab == 'received'){
          this.listImpl.fetchReceivedFilesListView(list)
        } else if (tab == 'sharedlinkbyme'){
          this.listImpl.fetchSharedLinkByMeListView(list);
        }
      }else{
          if(this.universalService.isUserOnSharedLinkByMe && this.listService.sharedLinkByMeSortOrder == "&sort=%2BshareName") {
            this.sortByName(list);
          } else {
            this.sortByDates(list);
          }
          this.bindMultiSelect();
      }
    }

    checkIfTabIsEmpty(list){
      if(list.length == 0){
        if(this.universalService.isUserOnSharedLinkByMe) {
          this.universalService.emptyShared = false;
          this.universalService.emptySharedLink = true;
        } else {
          this.universalService.emptySharedLink = false;
          this.universalService.emptyShared = true;
        }
      }else{
        this.universalService.emptySharedLink = false;
        this.universalService.emptyShared = false;
      }
    }

    fetchNextLink(resp){
      if (resp["nextLink"]) {
        if(resp["nextLink"].includes('+')){
          this.nextLink = resp["nextLink"].replace('+',"%2B")
        }else{
          this.nextLink = resp["nextLink"]
        }
      } else {
        this.nextLink = ""
      }
    }

    bindMultiSelect(){
        this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
        this.multiSelect.bindMultiSelectLibrary("#sharedFilesWrapperId", "list_info", ".listItem:visible", false,this.universalService.virtualGridEnabled,false);
        this.multiSelect.bindMultiSelectUIevent(".main-wrapper", ".list_file_child");   
    }

    sortByName(files){
      this.universalService.sortByNameArray = [];
      var array  = this.customSort.sortByNames(files,this.universalService.sortByNameArray)
      this.universalService.sortByNameArray = array[0];
      this.universalService.objectsPreviewArray = array[1];
      this.shareAccessService.sharedFilesList = array[1];
      this.universalService.loadGridView = true;
      if(this.universalService.sortByNameArray.length == 0 && this.universalService.foldersArray.length == 0){
        this.loggerService.log("inside empty all files",this.universalService.sortByNameArray)
        this.universalService.emptyTab = true;
        this.universalService.showLoader = false;
        return
      }else{
        this.universalService.emptyTab = false;
      }
      setTimeout(() => {
        this.universalService.showLoader = false;  
        if(this.universalService.isViewFileClicked == true) {
          this.universalService.isViewFileClicked == false;
          document.getElementsByClassName('list_info')[0].scrollIntoView();
        }
      }, 10);

      AppEvents.multiSelectEvent.next({"dataArray":this.universalService.sortByNameArray.concat(this.universalService.foldersArray)})
    }

    sortByDates(files){
        var array  = [];
        if(this.universalService.isUserOnSharedLinkByMe) {
          array  = this.customSort.sortByDates(files,this.sortByDateArray,[],"createdDate");
        } else {
          array  = this.customSort.sortByDates(files,this.sortByDateArray,[],"modifiedDate");
        }
        this.sortByDateArray = array[0];
        this.universalService.objectsPreviewArray = array[1];
        this.shareAccessService.sharedFilesList= array[1];
        this.loggerService.log("sort by date array",this.sortByDateArray)  
        setTimeout(() => {
            this.universalService.showLoader = false;  
        }, 10);
        AppEvents.multiSelectEvent.next({"dataArray":this.sortByDateArray.concat(this.universalService.foldersArray)})  
    }

    createUrlForNextLinkOnDesktop(url,currentTab) {
      var options
      options = this.listService.listOptions
      if (options.api.getVerticalPixelRange().top == 0)
        this.universalService.scrollToTopIcon = false;
      else
        this.universalService.scrollToTopIcon = true;

        if(this.listsize - options.api.getLastDisplayedRow() < 3 && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
          this.previousPageNo = this.currentPageNo;
          setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
            this.currentPageNo ++;
            let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
            await this.appendData(objList,currentTab);
            this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
          }, this.paginationService.bufferTimeoutForFetchingData);
        }
        if (this.listsize - options.api.getLastDisplayedRow() < 3) {
          if ((this.previousLink != this.nextLink)) {
            this.previousLink = this.nextLink
            if (this.nextLink != "") {
              this.universalService.showLoader = true;
              this.fetchNextPageData(url,currentTab);
            } else {
    
            }
          } else {
    
          }
        }
      }
    
      createUrlForNextLinkOnMobile(docheignt, toppos, url,currentTab) {
        if (toppos == 0) {
          this.universalService.scrollToTopIcon = false;
        } else {
          this.universalService.scrollToTopIcon = true;
          let checkIfContaineris95PercScrolled = this.universalService.virtualGridEnabled ? true : (toppos + $(".scrollableContainer").innerHeight()) >= (0.95 * docheignt)

          if(checkIfContaineris95PercScrolled && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
            this.previousPageNo = this.currentPageNo;
            setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
              this.currentPageNo ++;
              let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
              await this.appendData(objList,currentTab);
              this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
            }, this.paginationService.bufferTimeoutForFetchingData);
          }

          if (checkIfContaineris95PercScrolled && this.nextLink != "" && this.previousLink != this.nextLink) {
            this.previousLink = this.nextLink
            if (this.nextLink != "") {
              this.universalService.showLoader = true;
              this.fetchNextPageData(url,currentTab)
            } else {
    
            }
          }
        }
      }
    
      fetchNextPageData(url,currentTab) {
        this.http.get(url).subscribe(
          async nextPageData => {
            if((nextPageData["objects"] ? nextPageData["objects"] : nextPageData["shares"]) && !this.paginationService.LOCAL_DB[this.currentPageNo]){ // this condition is added when user has scrolled all the buffer data, there is no buffer data left and API call is taking time or due to network latency to return data, post API response we are populating the data
              let bufferDataPresent = this.paginationService.checkIfBufferDataIsPresent();
              if(!bufferDataPresent){
                this.currentPageNo = Object.keys(this.paginationService.LOCAL_DB).length;
                this.previousPageNo = this.currentPageNo - 1;
                this.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"] ? nextPageData["objects"] : nextPageData["shares"]);
                this.fetchNextLink(nextPageData);
                let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
                await this.appendData(objList,currentTab);
                this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo);
                return;
              }
            }
            this.universalService.showLoader = false;
            this.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"] ? nextPageData["objects"] : nextPageData["shares"]);
            this.fetchNextLink(nextPageData);
          },
          err => {
            this.universalService.showErrorMessage(err);
          }
        )
      }
    
      appendData(objectsList,currentTab) {
        this.resizeableObjectList = this.resizeableObjectList.concat(objectsList);
        var list = this.customMetadata.segregateData(objectsList, 'allfiles');
        if (!this.universalService.isMobileDevice) {
          this.listsize = this.listsize + list.length;
          if(currentTab == 'sent'){
            this.listImpl.appendRowDataForSentFiles(list)
          } else if(currentTab == 'sharedlinkbyme'){
            this.listImpl.appendRowDataForSharedLinkByMeList(list)
          } else{
            this.listImpl.appendRowDataForReceivedFiles(list)
          }
        } else {
          this.sortByDates(list);
        }
      }

      fetchFolderData(url,currentTab,changedSortFromDropDown){
        var self = this;
        var sort = "default";
        sort = (this.shareAccessService.sortType=='lastModified')?'lm':'default';
        // if(changedSortFromDropDown && !this.universalService.isMobileDevice){
        //   this.listImpl.decideListOptions(currentTab == 'sent' ? 'sharedbyme' : "sharedwithme");
        //   return
        // }
        return new Promise(function(resolve,reject){
            self.http.get(url).subscribe(
                resp=>{
                   self.resetData();
                   self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
                   self.fetchNextLink(resp);
                   self.setFilesData(self.paginationService.getBufferDataForNextPage(self.currentPageNo),currentTab,sort);
                   self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
                },
                err=>{
                    self.universalService.showErrorMessage(err);
                    self.universalService.isServerError = false;
                    self.loggerService.log("error in fetching favorites for my albums",err)
                }
            )
        })
      }

      resetData(){
        this.nextLink = "";
        this.previousLink = "";
        this.universalService.showLoader = true;
        this.sortByDateArray = [];
        this.currentPageNo = 0;
        this.previousPageNo = -1;
        this.paginationService.LOCAL_DB = {}
        this.listService.cellclick = false;
        this.universalService.selectedNodes = [];
        this.shareAccessService.sharedFilesList = [];
        this.universalService.emptyTab = false;
        this.universalService.emptyShared = false;
        this.universalService.mobileSelectedObj = [];
        // this.listService.SelectAll(null);
        this.universalService.objectsPreviewArray = [];
        this.universalService.foldersArray = [];
        this.universalService.scrollToTopIcon = false;
        this.listsize = 0;
        this.universalService.scrollToTopIcon = false;
        this.universalService.emptyShared = false;
        this.universalService.deletedFileShare = false;
        this.universalService.emptySharedLink = false;
      }

      selectAll(event){
        this.listImpl.selectAll(event)
      }
      
  updateListView(obj, currentTab){
    var self = this;
    var sharedFolderDetails = this.localStorageService.getSharedFolder(true);

    let objArray = [obj];
    let newObjArr = objArray.map(obj=> (
      { ...obj, 
        recipientsObjRights: self.universalService.recipientsObjRights,
        shareKey: sharedFolderDetails.shareKey,
        isShared: true
    }));
    this.universalService.emptyShared = false;
    setTimeout(() => {
      this.listImpl.updateSharedListViewData(newObjArr, currentTab);
    }, 100);
  }


  updateSharedFilesData(obj) {
    let objectsList = [];
    var self = this;
    var sharedFolderDetails = this.localStorageService.getSharedFolder(true);

    objectsList.push(obj);
    objectsList.map(obj=>{
      obj["recipientsObjRights"] = self.universalService.recipientsObjRights;
      obj["shareKey"] = sharedFolderDetails.shareKey;
      obj["isShared"] = true;
    })
    let response = this.customMetadata.segregateData(objectsList, 'allfiles');
    this.sortByDates(response)
    // this.universalService.emptyTab = false;
    // this.universalService.emptyFolder = false;
    this.universalService.emptyShared = false;
  }

  initializeAgGridForIfUploadedInEmptyView(){
    if(this.router.url.includes('sharedbyme')){
      this.listImpl.initializeAgGridForIfUploadedInEmptyView('sharedbyme');
    }else{
      this.listImpl.initializeAgGridForIfUploadedInEmptyView('sharedwithme');
    }
    
  }


  getObjectMetadata(metadataURL){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(metadataURL).subscribe(
          info=>{
            resolve(info)
          },
          err=>{
            console.log('obj metadata err',err);
            reject(err)
          }
        )
    })
  }

}
